// Module
var code = "<span class=\"btn\" ng-class=\"btnStyle\" ng-click=\"onClick(model)\"><span ng-bind-html=\"to.btnHtml\"></span></span>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/action/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;